<script setup>
import {defineProps} from 'vue'
import ProviderThumbnail from '@/components/Anonymization/ProviderThumbnail.vue'

const props = defineProps(["data"])
</script>

<template>
  <div class="d-flex vertically-centered" v-if="props.data && props.data.length > 0">
    <ProviderThumbnail
      :data="{
        name: props.data[0].display_name || props.data[0].provider,
        thumbnail_url: props.data[0].thumbnail_url
      }"
      class="me-2"
    />
    <span>{{ props.data[0].display_name || props.data[0].provider }}</span>
    <span v-if="props.data.length > 1" class="text-muted ms-1">
      (+{{ props.data.length - 1 }} more)
    </span>
  </div>
</template>

<style scoped>
/* Scale down thumbnail to match table size */
:deep(.provider-thumbnail-container) {
  width: 16px;
  height: 16px;
}

:deep(.provider-thumbnail),
:deep(.provider-thumbnail-image) {
  width: 16px;
  height: 16px;
  font-size: 0.6rem;
}
</style>
